import httpClient from "./http-client";


class ConfiguracionesGeneralesService {
  private ENDPOINT = "/configuracion/general";

  /**
   * 
   * @returns 
   */  
  getAll() {
    return httpClient.get(this.ENDPOINT).then(response => {
        if (response.data) {
            return response.data;
        }
    });    
  }

  /**
   * 
   * @param id 
   * @param categoria 
   * @param valor 
   * @param descripcion 
   * @returns 
   */
  modificarConfiguracion(id: number, categoria: string, valor: any, descripcion: string) {
    return httpClient.put(`${this.ENDPOINT}/${id}`, {categoria, valor, descripcion});
  }
  
}

export default new ConfiguracionesGeneralesService();